import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@/common/utils/requireFeature';
import { FeatureKey } from '@/common/enums/feature-keys.enum';
import { PermissionGate } from '@/components/PermissionGate';
import { Permission } from '@/common/enums/permissions.enum';
import { PlaybookTriggersPage } from '@/features/playbooks/components/PlaybookTriggersPage';

export const Route = createFileRoute('/_authenticated/playbooks/triggers')({
  beforeLoad: async () => {
    await requireFeature(FeatureKey.CLIENT_PLAYBOOKS);
  },
  component: PlaybookTriggersRoute,
});

function PlaybookTriggersRoute() {
  return (
    <PermissionGate permission={Permission.PLAYBOOKS_TRIGGERS}>
      <PlaybookTriggersPage />
    </PermissionGate>
  );
}
